var map = {
	"./ .svg": 2777,
	"./SDG/E-WEB-Goal-1.png": 5430,
	"./SDG/E-WEB-Goal-10.png": 8724,
	"./SDG/E-WEB-Goal-11.png": 1965,
	"./SDG/E-WEB-Goal-12.png": 198,
	"./SDG/E-WEB-Goal-13.png": 3999,
	"./SDG/E-WEB-Goal-14.png": 5968,
	"./SDG/E-WEB-Goal-15.png": 169,
	"./SDG/E-WEB-Goal-16.png": 1986,
	"./SDG/E-WEB-Goal-17.png": 3531,
	"./SDG/E-WEB-Goal-2.png": 2461,
	"./SDG/E-WEB-Goal-3.png": 9956,
	"./SDG/E-WEB-Goal-4.png": 9899,
	"./SDG/E-WEB-Goal-5.png": 898,
	"./SDG/E-WEB-Goal-6.png": 9689,
	"./SDG/E-WEB-Goal-7.png": 4864,
	"./SDG/E-WEB-Goal-8.png": 8487,
	"./SDG/E-WEB-Goal-9.png": 798,
	"./alpine-layers.png": 2983,
	"./arrow_drop.svg": 1258,
	"./clippy-gray.svg": 4448,
	"./clippy-white.svg": 1684,
	"./cross.svg": 8045,
	"./ferrari-layers.png": 8825,
	"./google.png": 6702,
	"./ketchup.png": 449,
	"./layer-text-2.png": 6863,
	"./layer-text-3.png": 3062,
	"./layer-text.png": 2702,
	"./layers.png": 6597,
	"./location.svg": 2254,
	"./logo.png": 2806,
	"./mercedes-layers.png": 7024,
	"./one-five-black.png": 5492,
	"./one-five-blue-trademark.png": 5343,
	"./one-five-blue.png": 3485,
	"./one-five-green.png": 7620,
	"./one-five-icon-black.png": 2488,
	"./one-five-icon-white.png": 9954,
	"./one-five-orange.png": 4919,
	"./one-five-white-trademark.png": 2524,
	"./one-five-white.png": 4750,
	"./package.svg": 6901,
	"./pet-food-peach.svg": 4511,
	"./pet-food.svg": 3267,
	"./plus_icon.svg": 2477,
	"./sachet.png": 8989,
	"./solution-1.png": 1060,
	"./tea-hero-blue.jpg": 7975,
	"./three-dots.svg": 2574,
	"./world-map.svg": 3360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;